import { useState } from 'react';

const AddHolidayCalendarPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddHolidayCalendarPopup, setAddHolidayCalendarPopup] =
      useState<boolean>(false);

    const addHolidayCalendarPopupToggleHandler = () => {
      setAddHolidayCalendarPopup(!showAddHolidayCalendarPopup);
    };

    return (
      <Component
        showAddHolidayCalendarPopup={showAddHolidayCalendarPopup}
        addHolidayCalendarPopupToggleHandler={
          addHolidayCalendarPopupToggleHandler
        }
        {...props}
      />
    );
  };

export default AddHolidayCalendarPopupHOC;
